import React from 'react';
import { connect, useSelector } from "react-redux";
import Button from "components/button";
import IndexModal from "components/modal";
import { BUTTON_ICONS } from "../../variables/constants";
import { addActiveModal, removeActiveModal } from '../../redux/layout/layoutState';
import { useCRUDAccess } from "utils/useCRUDAccess";
import { displayIcon } from 'variables/icons';

function PopupButton({ 
	id, 
	activeModals, 
	showModal, 
	hideModal, 
	title, 
	label, 
	icon, 
	children, 
	btnClass, 
	action, 
	moduleId=0, 
	modalWidth=900, 
	modalContainerClass,
	useCustomClass=true,
	iconName,
	iconClass,
	badgeValue=null,
	badgeBgColor="bg-red-500",
	...rest 
}) {
	const Icon = icon ?? BUTTON_ICONS[label];
	const isVisible = activeModals?.includes(id);
	const checkCRUDAccess = useCRUDAccess();
	
	const wrappedChildren = typeof children === "function"
    ? children({ closeModal: () => hideModal(id) })
    : React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { closeModal: () => hideModal(id) })
          : child
      );

	return (
		<>
			{(moduleId === 0 || checkCRUDAccess(moduleId, action)) && 
				<>
					<Button
						extra={`crud-button ${btnClass}`}
						onClick={() => showModal(id)}
						aria-haspopup="dialog"
						aria-expanded={showModal}
						{...rest}
					>
						{iconName ? 
							displayIcon(iconName, iconClass ?? "sm:mr-2 w-4 h-4")
						: Icon && <Icon size={16} className={label ? "sm:mr-2" : ""} />
						}
						{label && (
							<span className="hidden sm:inline">{label}</span>
						)}
						{badgeValue &&
						<span className={`${badgeBgColor ?? 'bg-red-500'} text-xs font-medium whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden absolute -top-2 -right-2 text-white border-2 border-white h-6 w-6 rounded-full p-0 flex items-center justify-center`}> 
							{badgeValue}
						</span>
						}
					</Button>

					<IndexModal
						open={isVisible}
						onClose={() => hideModal(id)}
						title={title}
						description={rest.description}
						icon={Icon && <Icon />}
						width={modalWidth}
						modalContainerClass={modalContainerClass}
						useCustomClass={useCustomClass}
					>
						<div className="w-full">
							{wrappedChildren}
						</div>
					</IndexModal>
				</>
			}
		</>
	);
}

const mapStateToProps = (state) => ({
	activeModals: state.layout.activeModals,
});

const mapDispatchToProps = (dispatch) => ({
	showModal: (id) => dispatch(addActiveModal(id)),
	hideModal: (id) => dispatch(removeActiveModal(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PopupButton);
